import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { SEO } from '@/constants/seo'
import { ROUTES } from '@/constants/routes'

const pageMeta: Record<string, { title: string; description: string }> = {
  [ROUTES.HOME]: SEO.pages.home,
  [ROUTES.ABOUT]: SEO.pages.about,
  [ROUTES.SERVICES]: SEO.pages.services,
  [ROUTES.SERVICES_CONSULTATIONS]: SEO.pages.consultations,
  [ROUTES.SERVICES_SCANS]: SEO.pages.scans,
  [ROUTES.SERVICES_INTEGRATED_HEALTH]: SEO.pages.integratedHealth,
  [ROUTES.SERVICES_COURSES]: SEO.pages.courses,
  [ROUTES.WORK_WITH_ME]: SEO.pages.workWithMe,
  [ROUTES.WOMENS_HEALTH]: SEO.pages.womensHealth,
  [ROUTES.CHRONIC_HEALTH]: SEO.pages.chronicHealth,
  [ROUTES.BOOKS]: SEO.pages.books,
  [ROUTES.TRAINING]: SEO.pages.training,
  [ROUTES.PRODUCTS]: SEO.pages.products,
  [ROUTES.BLOG]: SEO.pages.blog,
  [ROUTES.CONTACT]: SEO.pages.contact,
}

function setMeta(selector: string, attr: string, value: string) {
  const el = document.querySelector(selector)
  if (el) el.setAttribute(attr, value)
}

const PageSeo = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)

    const meta = pageMeta[location.pathname] ?? {
      title: SEO.defaultTitle,
      description: SEO.defaultDescription,
    }

    const path = location.pathname === '/' ? '' : location.pathname
    const canonicalUrl = `${SEO.siteUrl}${path}`

    document.title = meta.title

    setMeta('meta[name="description"]', 'content', meta.description)
    setMeta('meta[property="og:title"]', 'content', meta.title)
    setMeta('meta[property="og:description"]', 'content', meta.description)
    setMeta('meta[property="og:url"]', 'content', `${canonicalUrl}/`)
    setMeta('meta[name="twitter:title"]', 'content', meta.title)
    setMeta('meta[name="twitter:description"]', 'content', meta.description)
    setMeta('link[rel="canonical"]', 'href', `${canonicalUrl}/`)
  }, [location])

  return null
}

export default PageSeo
